import React, { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = () => {
  const [isDarkMode, setIsDarkMode] = useState(true);

  useEffect(() => {
    // Check local storage or system preference
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light') {
      setIsDarkMode(false);
      document.documentElement.classList.add('light');
    } else {
      document.documentElement.classList.remove('light');
    }
  }, []);

  const toggleTheme = () => {
    if (isDarkMode) {
      document.documentElement.classList.add('light');
      localStorage.setItem('theme', 'light');
      setIsDarkMode(false);
    } else {
      document.documentElement.classList.remove('light');
      localStorage.setItem('theme', 'dark');
      setIsDarkMode(true);
    }
  };

  return (
    <button
      onClick={toggleTheme}
      className={`fixed top-6 right-6 sm:top-8 sm:right-24 z-[60] transition-all duration-300 group ${
        isDarkMode ? 'text-white' : 'text-black'
      }`}
      aria-label="Toggle Theme"
    >
      {isDarkMode ? (
        <Sun className="group-hover:rotate-45 transition-transform duration-500" size={20} />
      ) : (
        <Moon className="group-hover:-rotate-12 transition-transform duration-500" size={20} />
      )}
    </button>
  );
};

export default ThemeToggle;
